<template>
    <div class="menu">
        <img src="../assets/logo.png" class="logo">
        <div class="menu-box">
            <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">首頁 </div>
            <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">核心優勢</div>
            <div class="about-us" :class="step == 4 || step == 5 || step == 6 ? 'select' : ''" @click="dropDown()">
                <div class="about">關於我們 <div class="arrow"></div>
                </div>
                <div class="drop-down-box">
                    <!-- <div class="item" @click="selectMenu(4)">精英簡介</div> -->
                    <div class="item" @click="selectMenu(6)">公司簡介</div>
                    <div class="item" @click="selectMenu(5)">隱私政策</div>
                </div>
            </div>
            <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">聯繫我們</div>
            <!-- <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">精英簡介</div>
            <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">招聘信息</div>
            <div :class="step == 6 ? 'select' : ''" @click="selectMenu(6)">合作品牌</div> -->
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            console.log(value);
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "coreStrengths" }); break;
                case 3: this.$router.push({ path: "aboutUs" }); break;
                case 4: this.$router.push({ path: "legalPerson" }); break;
                case 5: this.$router.push({ path: "offers" }); break;
                case 6: this.$router.push({ path: "introduction" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        },
        dropDown() {

        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    padding: 10px 80px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
        // width: 243px;
        height: 32px;
    }

    .menu-box {
        display: flex;
        width: 700px;
        line-height: 56px;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        cursor: pointer;

        div {
            padding: 0px 20px;
            position: relative;
        }

        .about-us {
            overflow: hidden;

            &:hover {
                overflow: visible;
            }

            .about {
                display: flex;
                align-items: center;
                justify-content: center;

                .arrow {
                    width: 10px;
                    height: 10px;
                    border-top: 3px solid #999;
                    border-right: 3px solid #999;
                    transform: rotate(45deg);
                    padding: 0px;
                }
            }

            .drop-down-box {
                position: absolute;
                left: 0px;
                top: 100%;
                width: 160px;
                height: 98px;
                background: #FFFFFF;
                border: 1px solid #DBDBDB;
                padding: 0px;

                .item {
                    font-size: 18px;
                    font-weight: 400;
                    color: #333333;
                    height: 36px;
                    line-height: 36px;

                    &:hover {
                        background: #E6E9EC;
                    }
                }
            }
        }

    }

    .select {
        background: #1C539D;
        color: #fff;
    }
}
</style>